import { Icon, Link, RyeconInfoOutline, Tooltip } from '@dbt-labs/sourdough';

const COST_INSIGHTS_DOCS_URL =
  'https://docs.getdbt.com/docs/explore/set-up-cost-insights';

interface InfoTooltipProps {
  connectionSettingsUrl?: string;
}

export const InfoTooltip = ({ connectionSettingsUrl }: InfoTooltipProps) => {
  return (
    <div data-testid="cost-info-tooltip">
      <Tooltip
        content={
          <div>
            We use a default compute cost unit to detect cost reduction.{' '}
            {connectionSettingsUrl && (
              <>
                This can be configured in{' '}
                <Link isInternal to={connectionSettingsUrl}>
                  your Connection settings.
                </Link>{' '}
              </>
            )}
            Learn more{' '}
            <Link isInternal={false} shouldOpenNewTab to={COST_INSIGHTS_DOCS_URL}>
              here
            </Link>
            .
          </div>
        }
      >
        <Icon ryecon={RyeconInfoOutline} alt="Cost insights information" />
      </Tooltip>
    </div>
  );
};
